import RoutesMap from "../../route_control/RouteControl"
import {
    CountryList,
    StateList,
    DistrictList,
    TehsilList,
    CityList,
    CategoryList,
    SubCategoryList,
    ServiceList,
    PlanList,
    DesignationList,
    ExpenseCategoryList
} from "../../pages/master"

export const MasterImport = {
    RoutesMap,
    CountryList,
    StateList,
    DistrictList,
    TehsilList,
    CityList,
    CategoryList,
    SubCategoryList,
    ServiceList,
    PlanList,
    DesignationList,
    ExpenseCategoryList
}